<template>
    <div class="dropdown-menu-project" v-if="salesCard != null" id="dropdown-menu-project" :class="{'open' : openSendwich}">
        <div class="container">
            <div class="drop-down-container">
                <div class="col-left">

                    <div class="drop-down-mobile-header" v-if="isMobileChecker">
                        <div class="lang-selector">
                            <ul>
                                <li :class="{'active' : globalLang == 'kz/'}"><a href="#" @click.prevent="setLocale('kz/')">Қаз</a></li>
                                <li :class="{'active' : globalLang == ''}"><a href="#" @click.prevent="setLocale('')">Рус</a></li>
                            </ul>
                        </div>
                        <div class="phone">
                            <div class="icon-phone">
                                <svgIcon name="phone" />
                            </div>
                            <a :href="'tel:' + salesCard.shablon_project_phone">
                                <p>{{salesCard.shablon_project_phone}}</p>
                            </a>
                        </div>
                    </div>

                    <shablongNav></shablongNav>
                </div>
                <div class="col-right" v-if="!isMobileChecker && salesCard.office_card.length">
                    <div class="office-item">
                        <h3>{{salesCard.shablon_project_adres.title}}</h3>
                        <p><span>{{salesCard.shablon_project_adres.city}}</span>{{salesCard.shablon_project_adres.adres}}</p>
                    </div>
                    <a href="#" v-scroll-to="{
                        el: '#land-form-top',
                        offset: offsetResponse
                    }" class="btn-call" @click="closeMobileMenu">{{salesCard.shablon_form_btn}}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import shablongNav from '@/components/sales-land-partials/land-nav.vue'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'Burger-Menu',
        components: {
            svgIcon,
            shablongNav,
        },
        data () {
            return {
                iSmobile: false,
                openSelectLang: false,
                dataLang: '',
                langOpen: false,
                globalLang: window.GlobalLang, 
                projectHost: window.host,
                offset: -150,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            openSendwich: 'loadOpenSendwich',
            isMobileChecker: 'loadIsMobileChecker',
            offsetResponse: 'loadOffsetResponse',
        }),
        methods: {
            setLocale(lang) {
                localStorage.setItem('languageShablon', lang);
                document.location.reload(true);
            },
            closeMobileMenu() {
                this.$store.commit('Open_Sendwich', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/burger-menu/burger-menu.scss';
    @import '@/styles/components/burger-menu/burger-menu-respond.scss';
</style>